import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import { CollectionFunctionGroupMenuActionsType } from 'routes/CollectionFunctionGroup/CollectionFunctionGroup.types';
import ModalDialog from 'shared/modal/dialog';
import './collection-function-group-list-menu.scss';
import { Contact } from 'data/contact/contact.types';

type Props = {
  selectedContact?: Contact;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const ContactListMenu: FunctionComponent<Props> = ({
  selectedContact,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedContact == null) {
    return null;
  }

  return (
    <div data-testid="CollectionFunctionGroupListMenu" className="collection-function-group-list-menu">
      {hasPrivilegesToCreate && (
        <Button
          className="collection-function-group-list-menu-button"
          data-testid={`${CollectionFunctionGroupMenuActionsType.Edit}-button`}
          text={t('collectionFunction.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && (
        <Button
          className="collection-function-group-list-menu-button"
          data-testid={`${CollectionFunctionGroupMenuActionsType.Delete}-button`}
          text={t('collectionFunction.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('collectionFunctionGroup.deletePopup.title')}
        displayMessage={t('collectionFunctionGroup.deletePopup.message', { name: selectedContact.name })}
        actionText={t('collectionFunctionGroup.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default ContactListMenu;
